// extracted by mini-css-extract-plugin
export default {"body":"DeleteOutlineModal_body__2B4rf"};